export enum AttachmentLoadState {
    notLoaded,
    loaded,
    loadFailed,
}
